import type { Action } from 'redux'
import type { InvokeDefinition } from '../../signalr/types'
import { payloadAsParam } from '../../signalr/helpers'
import {
  addUserEditorData,
  saveUserEditorDataSuccess,
  saveUserEditorDataFailure
} from './actions'
import type { UserEditorData } from './types'

export const fetchUserEditorDataDefinition: InvokeDefinition<
  [number],
  UserEditorData,
  Action
> = {
  method: 'GetUserEditorData',
  getParams: payloadAsParam,
  mapResponse: addUserEditorData
}

export const saveUserEditorDataDefinition: InvokeDefinition<
  [UserEditorData],
  UserEditorData[],
  Action
> = {
  method: 'SaveUserEditorData',
  getParams: payloadAsParam,
  mapResponse: saveUserEditorDataSuccess,
  mapError: saveUserEditorDataFailure
}
